import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

//authentication code
import { initializeApp } from "firebase/app";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyD8b8LQSh7E1JZ9JMu6S8fTvrc5fkn7Ndk",
  authDomain: "my-test-blog-57b20.firebaseapp.com",
  projectId: "my-test-blog-57b20",
  storageBucket: "my-test-blog-57b20.firebasestorage.app",
  messagingSenderId: "516999075763",
  appId: "1:516999075763:web:d6f3e5ee2b21b8cbecddc6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
